"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getReportSettings = exports.fetchReportSettingsAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _fetchHelpers = require("../fetchHelpers");
var _ReportsSdk = require("../../../report-service/ReportsSdk");
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial
};
const reportSettingsSlice = (0, _toolkit.createSlice)({
  name: "reportSettings",
  initialState,
  reducers: {
    reportSettingsFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    reportSettingsFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.data = action.payload;
    },
    reportSettingsFetchError(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
    }
  }
});
const {
  reportSettingsFetchStart,
  reportSettingsFetchSuccess,
  reportSettingsFetchError
} = reportSettingsSlice.actions;
const fetchReportSettingsAction = _ref => {
  let {
    projectId
  } = _ref;
  return async (dispatch, getState) => {
    const state = getState();
    if (!(0, _fetchHelpers.isLoading)(state.reportSettings) && !(0, _fetchHelpers.isErrored)(state.reportSettings)) {
      try {
        dispatch(reportSettingsFetchStart());
        const payload = await (0, _ReportsSdk.getReportsSdk)().fetchSettings({
          projectId
        });
        dispatch(reportSettingsFetchSuccess(payload));
      } catch (e) {
        console.error(e);
        dispatch(reportSettingsFetchError());
      }
    }
  };
};
exports.fetchReportSettingsAction = fetchReportSettingsAction;
const reducer = exports.reducer = reportSettingsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = reportSettingsSlice.name;
const getReportSettingsState = state => state[STATE_KEY];
const getReportSettings = exports.getReportSettings = (0, _toolkit.createSelector)(getReportSettingsState, state => state.data);
//# sourceMappingURL=reportSettings.js.map